<div class="popover popover--{{ direction }}">
  <ng-content></ng-content>
</div>
